export default __webpack_public_path__ + "static/media/ill-4.784fd674.svg";